import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, EventoInicio } from './types';

export const INITIAL_STATE: EventoInicio = {
	status: 0,
	data: null,
	detailsStartSection: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): EventoInicio {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EVENTO_INICIO_REQUEST: {
				draft.status = 100;
				break;
			}

			case Types.EVENTO_INICIO_SUCCESS: {
				draft.status = action.payload.response.status;
				draft.data = null;
				draft.detailsStartSection = action.payload.request;
				break;
			}

			case Types.EVENTO_INICIO_FAILURE: {
				draft.status = action.payload.response.status;
				draft.data = null;
				draft.detailsStartSection = action.payload.request;
				break;
			}

			case Types.EVENTO_INICIO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.detailsStartSection = INITIAL_STATE.detailsStartSection;
				break;
			}

			default:
		}
		return draft;
	});
}
